import { axiosInstance } from '../../utils';
import { useMutation } from '@tanstack/react-query';
import { uploadFileToPresignedUrl } from '../createMedia';

interface FileUploadResponse {
  objectId: string;
}

const readFileAsBuffer = async (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};

interface UploadToPresignedUrlParams {
  presignedUrls: { url: string; partNumber: number }[];
  uploadId: string;
  file: File;
  onUploadProgress?: (percentCompleted: number) => void;
  signal?: AbortSignal;
}

export const uploadToPresignedUrl = async ({
  presignedUrls,
  uploadId,
  file,
  onUploadProgress,
  signal,
}: UploadToPresignedUrlParams): Promise<FileUploadResponse> => {
  const url = new URL(presignedUrls[0].url);
  const objectId = url.pathname.split('/').pop() || '';

  // const buffer = await readFileAsBuffer(file);
  await uploadFileToPresignedUrl(uploadId, presignedUrls, file, onUploadProgress, signal);

  return { objectId };
};

// -----------------------------------------------------------------------------------------------

interface UsePresignedUrlUploadOptions {
  onUploadProgress?: (percentCompleted: number) => void;
}

interface UsePresignedUrlUploadParams {
  presignedUrls: { url: string; partNumber: number }[];
  uploadId: string;
  file: File;
  signal?: AbortSignal;
}

export function usePresignedUrlUpload({ onUploadProgress }: UsePresignedUrlUploadOptions = {}) {
  return useMutation(
    ({ presignedUrls, uploadId, file, signal }: UsePresignedUrlUploadParams) =>
      uploadToPresignedUrl({ presignedUrls, uploadId, file, onUploadProgress, signal }),
    {
      onSuccess: (data) => data,
    }
  );
}
